import React from 'react';
import { graphql } from 'gatsby';
import CustomerReview from './CustomerReview';
const ModularCustomerReview = ({ data }) => {
  const { mode } = data;
  return <CustomerReview mode={mode} />;
};

export default ModularCustomerReview;
export const fragment = graphql`
  fragment ModularCustomerReview on DatoCmsCustomerReviewBlock {
    internal {
      type
    }
    id

    mode
  }
`;
